import { MessageBus } from '@podium/browser'
import { config } from '@finn-no/huck-config'
import { state } from './store'
import * as api from './api'
import debounce from 'femtobounce'

const MB_CHANNEL = 'classified-innfinn-channel'

// this maps innfinn keys to our API values
const eventMap = {
  year: 'modelYear',
  effect: 'horsePower',
  make: 'make',
  'model-and-make-id': 'modelAndMakeId',
  mileage: 'mileage',
  warranty: 'warranty',
  tuned: 'isEngineTuned',
  'has-undergone-repairs': 'hasUndergoneRepairs',
  'first-registration': 'firstRegistration',
}
const debouncedUpdate = debounce((...args) => api.update(...args))
export const setupMessageBus = () => {
  const messageBus = new MessageBus()

  if (config.isDev) window.mb = messageBus

  const useCallback = (name) => ({ payload } = {}) => {
    state[name] = payload ?? null
    debouncedUpdate({ sellerAction: 'update', values: state })
  }
  function immediateSubscribe(eventName) {
    const stateName = eventMap[eventName]
    const callback = useCallback(stateName)
    const topic = `pf-${eventName}`
    messageBus.subscribe(MB_CHANNEL, topic, callback)
    const maybeValue = messageBus.peek(MB_CHANNEL, topic)
    if (maybeValue != null) callback(maybeValue)
  }

  for (const e of Object.keys(eventMap)) immediateSubscribe(e)
}
